import * as React from "react";

function Dashboard(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 19" fill="none" {...props}>
      <path
        d="M10 18.906v-10h8v10h-8zm-10-8v-10h8v10H0zm6-2v-6H2v6h4zm-6 10v-6h8v6H0zm2-2h4v-2H2v2zm10 0h4v-6h-4v6zm-2-16h8v6h-8v-6zm2 2v2h4v-2h-4z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoDashboard = React.memo(Dashboard);
export default MemoDashboard;
